import React from "react";

export const Logo = ({ className = "h-24" }) => (
  <img
    src="/elevate-logo.png"
    alt="CC Elevate"
    className={`${className} w-auto mx-auto select-none`}
    draggable={false}
    data-testid="elevate-logo"
  />
);
